import { createContext } from "react";
const SelfSelectContext = /*#__PURE__*/createContext({
  columnsRef: {},
  renderRowChildren: children => children
});
export default SelfSelectContext;